import { render, staticRenderFns } from "./ChecksForm.vue?vue&type=template&id=59fca433"
import script from "./ChecksForm.vue?vue&type=script&lang=js"
export * from "./ChecksForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59fca433')) {
      api.createRecord('59fca433', component.options)
    } else {
      api.reload('59fca433', component.options)
    }
    module.hot.accept("./ChecksForm.vue?vue&type=template&id=59fca433", function () {
      api.rerender('59fca433', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Formularios/Formularios1/CheckFields/ChecksForm.vue"
export default component.exports